var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Hero'),_c('div',{staticClass:"home-grid"},[_c('TopArtists'),_c('Player'),_c('Genres'),_c('TopCharts')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }